import { render, staticRenderFns } from "./BDXStatusModalItemSkeleton.vue?vue&type=template&id=40e176b6"
import script from "./BDXStatusModalItemSkeleton.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalItemSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports